import { Directive, inject } from '@angular/core';
import { truncateToPoint2D } from '../../../cross-team-shared/misc-utils';
import { shellConnectorToken } from '../../../team-apis/core/shell-connector';
import { viewTitles } from '../../misc-services/side-view-rotation.service';
import { PointCloudContentStore } from '../../state/point-cloud-content-store';
import { KdTreeService } from '../../utils/kd-tree.service';
import { getShapeForEventTracking } from '../../utils/misc-utils';
import { ensureKeyLocation } from '../../utils/point-cloud-interpolation-helper';

@Directive()
export abstract class AbstractAutoGroundButtonComponent {
  private readonly store = inject(PointCloudContentStore);
  private readonly kdTreeService = inject(KdTreeService);
  private readonly shellConnector = inject(shellConnectorToken);

  groundCuboid() {
    const { position, scale } = this.store.getFocusedShapeLocation();
    const focusedCuboidStore = this.store.getFocusedShapeStore()!;
    const groundZ = this.kdTreeService.getGroundZ(truncateToPoint2D(position));

    ensureKeyLocation(
      focusedCuboidStore('key_locations'),
      this.store.state().render.frameNumber,
    )('position')(2).set(groundZ + scale[2] / 2);

    this.shellConnector.pushAndTrack({
      id: 'edit_shape_points',
      bucket: 'adjustment',
      shapes: [getShapeForEventTracking(focusedCuboidStore.state())],
      // axis Y is 1
      view: viewTitles.eventTracking[1],
      source: 'button',
      method: 'auto_ground_side_panel',
    });
  }
}
